import Event from 'ol/events/Event';

export const EXTERNAL_CONDITION_CHANGE = 'condition.change.external';

export class ExternalConditionChangeEvent extends Event {

  constructor (newConditionValuesSetHash) {
    super(EXTERNAL_CONDITION_CHANGE);
    this.newConditionValuesSetHash = newConditionValuesSetHash;
  }

}
